import { React } from 'react';
import ServiceSection from '../../../../ServiceSection/ServiceSection';
import SatelliteText from '../../../SatelliteText/SatelliteText';
import satelliteIcon from '../../../satelliteIcon';

const CustomVsStandardSoftware2 = props => (
    <ServiceSection noPadBottom noPadTitle singleTitle icon={satelliteIcon} {...props} page="customVsStandardSoftware" section="whatStandard">
        <div className='TextGroup Satellite'>
            <div className='container-custom subtitle'>
                <SatelliteText t={props.t} prefix="customVsStandardSoftware:whatStandard" first noPadBottom />
            </div>
        </div>
    </ServiceSection>
);

export default CustomVsStandardSoftware2;
